import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { Player } from 'ThreeTerminal_mobile';

const config = {
    width: 268,
    height: 156,
    autoplay: true,
};

const Detail = ({ width, height, loadingShow, content }) => {
    const [maskShow, setMaskShow] = useState(false);

    const handleMaskShow = () => {
        setMaskShow(!maskShow);

        document.querySelector('html').style.overflow = maskShow ? 'auto' : 'hidden';
        document.querySelector('body').style.overflow = maskShow ? 'auto' : 'hidden';
    };

    const img = content[0].thumbnails.image;
    const video = content[1];
    const textArr = content[2].thumbnails.image.map(item => item.url);
    const icon = content[3].thumbnails.image.map(item => item.url);
    const haibao = content[4].thumbnails.image.map(item => item.url);

    console.log(img);

    const getVideoData = video => ({
        title: video.title,
        videoPlayUrl: video.videoPlayUrl,
        duration: Number(video.duration),
        bigPosterUrl: video.posterUrl,
        vid: video.guid,
        guid: video.guid,
        categoryId: video.searchPath,
        mediaName: video.source,
        columnName: video.columnName,
    });

    const getItem = text => {
        if (text.indexOf('ifengimg') > -1) {
            return (
                <div key={text} className={styles.img_box}>
                    <div className={styles.img_bg} />
                    <img src={text} />
                </div>
            );
        }

        return <p key={text}>{text}</p>;
    };

    return (
        <div className={styles.box} style={{ display: loadingShow ? 'none' : 'block' }}>
            <div
                className={styles.hb_box}
                style={{
                    width,
                    height,
                    background: `url(${img[0].url}) no-repeat center top`,
                    backgroundSize: 'cover',
                }}>
                <div
                    className={styles.logo}
                    style={{
                        width: `${img[1].width / 2}px`,
                        height: `${img[1].height / 2}px`,
                        background: `url(${img[1].url}) no-repeat`,
                        backgroundSize: 'contain',
                    }}
                />
                <div className={styles.pb} />
            </div>
            <div className={styles.content}>
                <div className={styles.video_box}>
                    <div className={styles.bg} />
                    <div className={styles.video}>
                        <Player videoConfig={getVideoData(video)} playermsg={config} />
                    </div>
                </div>
                <div className={styles.text_box}>{textArr.map(item => getItem(item))}</div>
                <div className={styles.bottom_box}>
                    <a href={haibao}>
                        <img src={icon} alt="" />
                    </a>
                    <div className={styles.share} onClick={handleMaskShow} />
                </div>
                <div className={styles.bottom} />
            </div>
            {maskShow && (
                <div className={styles.mask} onClick={handleMaskShow}>
                    <div className={styles.share_img} />
                </div>
            )}
        </div>
    );
};

Detail.propTypes = {
    audio: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    loadingShow: PropTypes.bool,
    content: PropTypes.array,
};

export default errorBoundary(Detail);
